
<template>
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.5303 7.21967C10.8232 7.51256 10.8232 7.98744 10.5303 8.28033C10.2641 8.5466 9.8474 8.5708 9.55379 8.35295L9.46967 8.28033L6 4.811L2.53033 8.28033C2.26406 8.5466 1.8474 8.5708 1.55379 8.35295L1.46967 8.28033C1.2034 8.01406 1.1792 7.5974 1.39705 7.30379L1.46967 7.21967L5.46967 3.21967C5.73594 2.9534 6.1526 2.9292 6.44621 3.14705L6.53033 3.21967L10.5303 7.21967Z" fill="black"/>
</svg>
</template>
    
<script>
export default {
  components: {
  },
  props: {
  },
  data() {
    return {
    }
  },
}
</script>

<style lang="scss" scoped>
svg {
  height: 18px;
}  
</style>
  
    